import request from '@/utils/request';

/**
 * 获取appid
 * @param params
 * @returns {Promise<void>}
 */
export async function getAppId() {
  return request('/api/zeyin_school/h5/appid', {});
}

/**
 * 通过code获取认证信息
 * @param params
 * @returns {Promise<void>}
 */
export async function loginByCode(params) {
  return request('/api/zeyin_school/h5/login', {
    params,
    method: 'POST',
  });
}

